<h3 class="display-4" style="font-size: 30px">Before Vaccination</h3>

<div class="d-flex">
  <div class="p-2 align-self-start">
    <i class="fas fa-check"></i>
  </div>
  <div class="p-2 align-self-end" style="font-size: 16px">
    Make sure to register for the vaccine and book a slot on CO-WIN portal else
    it may take long.
  </div>
</div>

<div class="d-flex">
  <div class="p-2 align-self-start">
    <i class="fas fa-check"></i>
  </div>
  <div class="p-2 align-self-end" style="font-size: 16px">
    Wear approximate clothes(Short-sleeved shirts) for easier vaccination.
  </div>
</div>
<div class="d-flex">
  <div class="p-2 align-self-start">
    <i class="fas fa-check"></i>
  </div>
  <div class="p-2 align-self-end" style="font-size: 16px">
    Hydrate Yourself sufficiently And Have A proper meal.
  </div>
</div>
<div class="d-flex">
  <div class="p-2 align-self-start">
    <i class="fas fa-check"></i>
  </div>
  <div class="p-2 align-self-end" style="font-size: 16px">
    Consult a medical professional before receiving the shot if you are
    pregnant,have a congenital disease or allergic to drug.
  </div>
</div>
<div class="d-flex">
  <div class="p-2 align-self-start">
    <i class="fas fa-check"></i>
  </div>
  <div class="p-2 align-self-end" style="font-size: 16px">
    Carry your Aadhar and 4 digit secret code generated at time of registration
    on cowin portal.
  </div>
</div>
<div class="d-flex">
  <div class="p-2 align-self-start">
    <i class="fas fa-times"></i>
  </div>
  <div class="p-2 align-self-end" style="font-size: 16px">
    Avoid all beverage that contains caffeine and alcohol.
  </div>
</div>

<div class="d-flex">
  <div class="p-2 align-self-start">
    <i class="fas fa-times"></i>
  </div>
  <div class="p-2 align-self-end" style="font-size: 16px">
    Do not take the vaccine if you are suffering from COVID.
  </div>
</div>
